// DS: C25A
import React, { useContext } from 'react';
import FolderDropdownDesktop from './FolderDropdownDesktop';
import FolderDropdownMobileV3 from './FolderDropdownMobileV3';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
const FolderDropdown = (props)=>{
    const isMobile = useContext(MobileContext);
    if (isMobile) {
        return /*#__PURE__*/ React.createElement(FolderDropdownMobileV3, props);
    }
    return /*#__PURE__*/ React.createElement(FolderDropdownDesktop, props);
};
export default FolderDropdown;

//# sourceMappingURL=FolderDropdown.js.map